//
//
import {
  call,
  put,
  takeEvery,
  take,
  select,
  takeLatest,
} from "redux-saga/effects"

import {
  CAMPUSVIRTUAL_GET_CARTERA,
  CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA,
  CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS,
  CAMPUSVIRTUAL_WAIT_FOR_PROPERTY_TO_CHANGE,
  CAMPUSVIRTUAL_GET_CAMPUS,
  CAMPUSVIRTUAL_GET_CARRERAS,
  CAMPUSVIRTUAL_GET_PLANES,
  CAMPUSVIRTUAL_GET_TURNOS,
  CAMPUSVIRTUAL_GET_TRAYECTORIAS,
  CAMPUSVIRTUAL_GET_STATUS,
  CAMPUSVIRTUAL_GET_CONFIGURACION,
  CAMPUSVIRTUAL_GET_INGRESOSEGRESOS,
  CAMPUSVIRTUAL_GET_DATASEGMENTOS,
  CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS,
  CAMPUSVIRTUAL_POST_SENDTEMPLATE,
  CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL,
  CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD,
} from "./actionTypes"

import {
  getCampusVirtualCarteraSuccess,
  getCampusVirtualCarteraFail,
  getCampusVirtualCarteraComparativaSuccess,
  getCampusVirtualCarteraComparativaFail,
  getCampusVirtualUltimosRecibosSuccess,
  getCampusVirtualUltimosRecibosFail,
  getCampusVirtualCampusSuccess,
  getCampusVirtualCampusFail,
  getCampusVirtualCarrerasSuccess,
  getCampusVirtualCarrerasFail,
  getCampusVirtualPlanesSuccess,
  getCampusVirtualPlanesFail,
  getCampusVirtualTurnosSuccess,
  getCampusVirtualTurnosFail,
  getCampusVirtualTrayectoriasSuccess,
  getCampusVirtualTrayectoriasFail,
  getCampusVirtualStatusSuccess,
  getCampusVirtualStatusFail,
  getCampusVirtualConfiguracionSuccess,
  getCampusVirtualConfiguracionFail,
  getCampusVirtualIngresosEgresosSuccess,
  getCampusVirtualIngresosEgresosFail,
  getCampusVirtualDatasegmentosSuccess,
  getCampusVirtualDatasegmentosFail,
  getCampusVirtualAlumnosSegmentadosSuccess,
  getCampusVirtualAlumnosSegmentadosFail,
  postCampusVirtualSendTemplateSuccess,
  postCampusVirtualSendTemplateFail,
  setCampusVirtualMensajeExito,
  postCampusVirtualSendLinkPagoEmailSuccess,
  postCampusVirtualSendLinkPagoEmailFail,
  getCampusVirtualResumenPuntualidadSuccess,
  getCampusVirtualResumenPuntualidadFail,
} from "./actions"

import {
  get_From_DashboardController,
  get_From_CampusVirtualController,
  post_To_WhatsAppController,
  post_To_DashboardController,
} from "../../helpers/campusvirtualbackend_helper"

// Función para obtener el valor de "Mensaje_Exito"
function getValueFromParametrosApi(response, Nombre) {
  // Verificar si el response tiene la propiedad 'Parametros'
  if (response.hasOwnProperty("Parametros")) {
    // Buscar dentro del array 'Parametros' el response con Nombre 'Mensaje_Exito'
    const parametro = response.Parametros.find(item => item.Nombre === Nombre)

    if (parametro) {
      // Retornar el valor asociado a 'Mensaje_Exito'
      return parametro.Valor
    } else {
      // Manejo si 'Mensaje_Exito' no se encuentra
      return null
    }
  } else {
    // Manejo si 'Parametros' no existe en el response
    return null
  }
}
function* fetchCampusVirtualCartera({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualCarteraFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualCarteraSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualCarteraFail(error))
  }
}
function* fetchCampusVirtualCarteraComparativa({
  payload: { jsonparameters },
}) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        getCampusVirtualCarteraComparativaFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(getCampusVirtualCarteraComparativaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualCarteraComparativaFail(error))
  }
}
function* fetchCampusVirtualCampus({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualCampusFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualCampusSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualCampusFail(error))
  }
}
function* fetchCampusVirtualCarreras({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualCarrerasFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualCarrerasSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualCarrerasFail(error))
  }
}
function* fetchCampusVirtualPlanes({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualPlanesFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualPlanesSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualPlanesFail(error))
  }
}
function* fetchCampusVirtualTurnos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualTurnosFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualTurnosSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualTurnosFail(error))
  }
}
function* fetchCampusVirtualTrayectorias({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualTrayectoriasFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualTrayectoriasSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualTrayectoriasFail(error))
  }
}
function* fetchCampusVirtualStatus({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualStatusFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualStatusSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualStatusFail(error))
  }
}
function* fetchCampusVirtualConfiguracion({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_CampusVirtualController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualConfiguracionFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualConfiguracionSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualConfiguracionFail(error))
  }
}
function* fetchCampusVirtualUltimosRecibos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCampusVirtualUltimosRecibos:Fail: ", response)
      yield put(getCampusVirtualUltimosRecibosFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCampusVirtualUltimosRecibos:success: ", response)
      yield put(getCampusVirtualUltimosRecibosSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCampusVirtualUltimosRecibos::Eror: " + error)
    yield put(getCampusVirtualUltimosRecibosFail(error))
  }
}
function* fetchCampusVirtualIngresosEgresos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualIngresosEgresosFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualIngresosEgresosSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualIngresosEgresosFail(error))
  }
}
function* fetchCampusVirtualDataSegmentos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCampusVirtualDatasegmentosFail(response.Mensaje_Detalle))
    } else {
      yield put(getCampusVirtualDatasegmentosSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualDatasegmentosFail(error))
  }
}
function* fetchCampusVirtualAlumnosSegmentados({
  payload: { jsonparameters },
}) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        getCampusVirtualAlumnosSegmentadosFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(getCampusVirtualAlumnosSegmentadosSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualAlumnosSegmentadosFail(error))
  }
}
function* fetchCampusVirtualSendTemplate({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_To_WhatsAppController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCampusVirtualSendTemplateFail(response.Mensaje_Detalle))
    } else {
      yield put(postCampusVirtualSendTemplateSuccess(response.Datos))

      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCampusVirtualMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(postCampusVirtualSendTemplateFail(error))
  }
}
function* fetchCampusVirtualSendLinkPagoEmail({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_To_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        postCampusVirtualSendLinkPagoEmailFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(postCampusVirtualSendLinkPagoEmailSuccess(response.Datos))

      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCampusVirtualMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(postCampusVirtualSendLinkPagoEmailFail(error))
  }
}
function* fetchCampusVirtualGetResumenPuntualidad({
  payload: { jsonparameters },
}) {
  try {
    const response = yield call(get_From_DashboardController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        getCampusVirtualResumenPuntualidadFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(getCampusVirtualResumenPuntualidadSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCampusVirtualResumenPuntualidadFail(error))
  }
}

function* watchPropertyChange(action) {
  let path = action.property.split(".") // Divide el path en partes

  //console.log("path: ", path)

  let currentValue = yield select(state =>
    path.reduce((acc, part) => acc[part], state)
  ) // Accede a la propiedad anidada

  //console.log("currentValue: ", currentValue)

  while (true) {
    yield take("*") // Captura cualquier acción
    let newValue = yield select(state =>
      path.reduce((acc, part) => acc[part], state)
    ) // Vuelve a obtener la propiedad anidada
    if (newValue !== currentValue) {
      //console.log("newValue: ", newValue)
      action.resolver(newValue)
      break
    }
  }
}
function* CampusVirtualSaga() {
  yield takeEvery(CAMPUSVIRTUAL_GET_CARTERA, fetchCampusVirtualCartera)
  yield takeEvery(
    CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA,
    fetchCampusVirtualCarteraComparativa
  )
  yield takeEvery(
    CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS,
    fetchCampusVirtualUltimosRecibos
  )
  yield takeLatest(
    CAMPUSVIRTUAL_WAIT_FOR_PROPERTY_TO_CHANGE,
    watchPropertyChange
  )
  yield takeLatest(CAMPUSVIRTUAL_GET_CAMPUS, fetchCampusVirtualCampus)
  yield takeLatest(CAMPUSVIRTUAL_GET_CARRERAS, fetchCampusVirtualCarreras)
  yield takeLatest(CAMPUSVIRTUAL_GET_PLANES, fetchCampusVirtualPlanes)
  yield takeLatest(CAMPUSVIRTUAL_GET_TURNOS, fetchCampusVirtualTurnos)
  yield takeLatest(
    CAMPUSVIRTUAL_GET_TRAYECTORIAS,
    fetchCampusVirtualTrayectorias
  )
  yield takeLatest(CAMPUSVIRTUAL_GET_STATUS, fetchCampusVirtualStatus)
  yield takeLatest(
    CAMPUSVIRTUAL_GET_CONFIGURACION,
    fetchCampusVirtualConfiguracion
  )
  yield takeLatest(
    CAMPUSVIRTUAL_GET_INGRESOSEGRESOS,
    fetchCampusVirtualIngresosEgresos
  )
  yield takeLatest(
    CAMPUSVIRTUAL_GET_DATASEGMENTOS,
    fetchCampusVirtualDataSegmentos
  )
  yield takeLatest(
    CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS,
    fetchCampusVirtualAlumnosSegmentados
  )
  yield takeLatest(
    CAMPUSVIRTUAL_POST_SENDTEMPLATE,
    fetchCampusVirtualSendTemplate
  )
  yield takeLatest(
    CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL,
    fetchCampusVirtualSendLinkPagoEmail
  )
  yield takeLatest(
    CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD,
    fetchCampusVirtualGetResumenPuntualidad
  )
}

export default CampusVirtualSaga
